<div [@pageLoad]="pageLoadState"  >
    <div
    class="gap-[40px] flex flex-col justify-around items-center pl-[64px] pr-[64px] pt-[40px] pb-[40px] bg-[#f8fafdff] w-[100%] h-[100%] " >
    <div class="w-full flex flex-row items-center justify-start">
        <button
            type="button"
            class="inline-flex items-center gap-[8px] h-[40px] px-[12px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[14px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
            (click)="onBackClick()"
            aria-label="Back">
            <svg class="w-[16px] h-[16px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>Back</span>
        </button>
    </div>
    <div class="gap-[16px] flex flex-col w-[100%] shrink-0 justify-start items-center self-stretch"> 
        <span
            class="shrink-0 justify-start items-start text-[#111215ff] text-center font-normal font-['archivo'] text-[24px] leading-[26px]">
            Welcome, <strong>{{userDetails.label}}</strong>. You’re successfully Checked-In </span>
        <div *ngIf="showInfoMessage" class="gap-[8px] flex flex-row shrink-0 justify-center items-start"> <img
                src="assets/icons/info.svg"
                alt="Information icon"
                loading="lazy"
                decoding="async"
                class="w-[28px] h-[28px] shrink-0 justify-start items-start " /> 
                <span *ngIf="infoMessageType === 'none'"
                class="shrink-0 justify-start items-start text-[#444955ff] text-left font-normal font-['archivo'] text-[20px] leading-[30px]">
                You haven't scheduled your {{ canShowTransport ? 'Meal and Transportation' : 'Meal' }} yet. <br> If you need {{ canShowTransport ? 'them' : 'it' }} today, please make your selection
                now. </span>
                <span *ngIf="infoMessageType === 'partial'"
                class="shrink-0 justify-start items-start text-[#444955ff] text-left font-normal font-['archivo'] text-[20px] leading-[30px]">
                Prebook {{ canShowTransport ? 'Meal and Transportation' : 'Meal' }} selections. If you need them <br> for the future dates, please make your selection now. </span>
                <span *ngIf="infoMessageType === 'all'"
                class="shrink-0 justify-start items-start text-[#444955ff] text-left font-normal font-['archivo'] text-[20px] leading-[30px]">
                If you want to edit your {{ canShowTransport ? 'Meal and Transportation' : 'Meal' }}, please make your selection now. </span>
        </div>
    </div>
    <div
        class="gap-[28px] flex flex-row w-[100%] shrink-0 justify-center items-start self-stretch pl-[308px] pr-[308px]">
       
        <button type="button"
        (click)="onSelectMealTransport()"
            class="relative group flex flex-col w-[270px] h-[270px] rounded-[16px] overflow-hidden shadow-[0px_18px_45px_rgba(15,23,42,0.25)] transition-transform duration-300 hover:-translate-y-[6px] hover:scale-[1.02]">
            <img src="assets/images/IMG00039.png" fetchpriority="high"  [alt]="canShowTransport ? 'Meal and transportation' : 'Meal'"
              
                class="w-[100%] h-[100%] object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
            <div
                class="absolute inset-x-0 bottom-0 h-[70px] flex flex-col justify-center items-center bg-gradient-to-t from-[#031323d9] via-[#03132380] to-transparent px-[16px]">
                <span
                    class="text-[#ffffffff] text-center font-semibold font-['archivo'] text-[18px] leading-[22px] tracking-[0.02em]">
                    {{ canShowTransport ? 'Meal & Transportation' : 'Meal' }}
                </span>
            </div>
        </button>
    </div>
</div>
</div>